import { render } from "./UserProfileTabs.vue?vue&type=template&id=b0474612&scoped=true&ts=true"
import script from "./UserProfileTabs.vue?vue&type=script&lang=ts"
export * from "./UserProfileTabs.vue?vue&type=script&lang=ts"

import "./UserProfileTabs.vue?vue&type=style&index=0&id=b0474612&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0474612"]])

export default __exports__